import {LeftArrow} from 'components/v2/icons/LeftArrow';
import {RightArrow} from 'components/v2/icons/RightArrow';

type CarouselPaginatorProps = {
  label: string;
  current: number;
  min: number;
  max: number;
  onBeforeClick?: () => any;
  onAfterClick?: () => any;
};

export const CarouselPaginator = ({
  label,
  onBeforeClick,
  onAfterClick,
  current,
  min,
  max,
}: CarouselPaginatorProps) => {
  return (
    <div className="flex gap-2 cursor-pointer ">
      <RightArrow onClick={onBeforeClick} disabled={current === max} />
      {/*mt should be the negative amount of gap-* */}
      <span className="text-[12px] font-bold mt-[-8px]">{label}</span>

      <LeftArrow onClick={onAfterClick} disabled={current === min} />
    </div>
  );
};
